module.exports = __webpack_public_path__ + "static/media/Home & Garden.1b04109c.svg";